import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../../store';
import axios from '../../../axios';

type State = {
  sites: string[];
  inspections: string[];
  turbines: string[];
};

const initialState: State = {
  sites: [],
  inspections: [],
  turbines: []
};

const homeAMSlice = createSlice({
  name: 'homeAM',
  initialState,
  reducers: {
    setSites: (state, action: PayloadAction<string[]>) => {
      state.sites = action.payload;
    },
    setInspections: (state, action: PayloadAction<string[]>) => {
      state.inspections = action.payload;
    },
    setTurbines: (state, action: PayloadAction<string[]>) => {
      state.turbines = action.payload;
    }
  }
});

export const { setSites, setInspections, setTurbines } = homeAMSlice.actions;

export default homeAMSlice.reducer;

export const getSites = (): AppThunk => async (dispatch, getState) => {
  try {
    const response = await axios.get<string[]>('sequence/sites');
    const sites = response.data;
    dispatch(setSites(sites));
  } catch (error) {}
};

export const getInspections = (site: string): AppThunk => async (dispatch, getState) => {
  try {
    const response = await axios.get<string[]>(`sequence/inspections/${site}`);
    const inspections = response.data;
    dispatch(setInspections(inspections));
  } catch (error) {}
};

export const getTurbines = (inspection: string): AppThunk => async (dispatch, getState) => {
  try {
    const response = await axios.get<string[]>(`sequence/turbines/${inspection}`);
    const turbines = response.data;
    dispatch(setTurbines(turbines));
  } catch (error) {}
};
